import React from "react";
import { motion } from "framer-motion";
import PageShell from "@/components/PageShell";
import { Rocket, LifeBuoy, MessageCircle, Clock } from "lucide-react";

const CARDS = [
  {
    icon: Rocket,
    label: "Growth & billing",
    email: "growth@clout-rise.com",
    desc: "Questions about plans, upgrades, billing, or getting the most out of your growth campaign.",
    testid: "contact-email-growth",
  },
  {
    icon: LifeBuoy,
    label: "Support & help",
    email: "support@clout-rise.com",
    desc: "Something not working, or need a hand with your account? Our support team replies fast.",
    testid: "contact-email-support",
  },
];

const Contact = () => (
  <PageShell
    testid="contact-page"
    kicker="Contact"
    title="Get in touch"
    subtitle="We'd love to hear from you. Reach the right team directly, or start a live chat from anywhere in the app."
  >
    <div className="grid sm:grid-cols-2 gap-6">
      {CARDS.map((c, i) => (
        <motion.a
          key={c.email}
          href={`mailto:${c.email}`}
          data-testid={c.testid}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.08 }}
          className="group rounded-2xl border border-border/50 bg-card p-8 hover:border-primary/40 transition-colors block"
        >
          <div className="w-11 h-11 rounded-lg bg-secondary/10 border border-secondary/20 flex items-center justify-center mb-5">
            <c.icon className="w-5 h-5 text-secondary" />
          </div>
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground mb-2">{c.label}</div>
          <div className="font-heading text-xl font-bold text-primary group-hover:underline">{c.email}</div>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{c.desc}</p>
        </motion.a>
      ))}
    </div>

    <div className="mt-10 grid sm:grid-cols-2 gap-6">
      <div className="rounded-2xl border border-border/50 bg-card p-6 flex items-start gap-4">
        <MessageCircle className="w-5 h-5 text-primary mt-0.5 shrink-0" />
        <div>
          <div className="font-heading font-semibold">Live chat</div>
          <p className="text-sm text-muted-foreground mt-1">Tap the chat bubble in the bottom-right corner of any page for instant answers — AI-assisted and escalated to our team when needed.</p>
        </div>
      </div>
      <div className="rounded-2xl border border-border/50 bg-card p-6 flex items-start gap-4">
        <Clock className="w-5 h-5 text-primary mt-0.5 shrink-0" />
        <div>
          <div className="font-heading font-semibold">Response time</div>
          <p className="text-sm text-muted-foreground mt-1">We reply to most messages within a few hours, and always within 24 hours. You can reply straight from your email — it lands right back in your support thread.</p>
        </div>
      </div>
    </div>
  </PageShell>
);

export default Contact;
